<template>
  <base-section id="downloads">
    <v-container>
      <!-- <v-alert type="info">
        <div>
          {{
            $t(
              "Whoopsie! Unfortunately, for Mac users, we never provided a newer version than v1_2_2 even though we announced new versions over the last months_ Sorry, this has been fixed now_"
            )
          }}
        </div>
      </v-alert> -->
      <div style="padding-left: 12px; padding-right: 12px; margin-bottom: 24px">
        <v-row>
          <h1>{{ $t("Prerequisites") }}</h1>
        </v-row>
        <v-row>
          {{
            $t(
              "Media Hoarder depends on the following 3rd party software_ Please make sure you have them ready on your system_"
            )
          }}
        </v-row>
        <v-row>
          <ul>
            <li>
              <a
                href="https://mediaarea.net/en/MediaInfo/Download"
                target="_blank"
                rel="noopener noreferrer"
                >MediaInfoCLI</a
              >
            </li>
            <li>
              {{ $t("a media player of your choice, we recommend") }}
              <a
                href="https://www.videolan.org/vlc/index.html"
                target="_blank"
                rel="noopener noreferrer"
                >VLC media player</a
              >
            </li>
          </ul>
        </v-row>
      </div>

      <div
        v-show="!selectedEdition"
        style="padding-left: 12px; padding-right: 12px; margin-bottom: 24px"
      >
        <v-row>
          <pricing-plan v-on:plan-selected="onPlanSelected"></pricing-plan>
        </v-row>
      </div>

      <div
        v-show="selectedEdition"
        style="padding-left: 12px; padding-right: 12px"
      >
        <div style="margin-bottom: 32px">
          <v-row>
            <h1 ref="selectEdition">{{ $t("Select Edition") }}</h1>
          </v-row>

          <v-row>
            <span style="margin-right: 16px">
              {{
                $t("You selected the {edition} edition_", {
                  edition: selectedEdition ? selectedEdition.title : "",
                })
              }}
              <span v-show="selectedEdition && selectedEdition.amount">{{
                $t("Thank you for supporting this project!")
              }}</span>
            </span>
            <a v-on:click="selectedEdition = null">{{ $t("BACK") }}</a>
          </v-row>
        </div>
        <v-row>
          <h1>{{ $t("Select Version") }}</h1>
        </v-row>
        <v-row>
          <v-select
            v-model="selectedVersion"
            v-bind:items="downloads"
            item-text="version"
            return-object
            v-on:change="onVersionChanged"
          ></v-select>
        </v-row>
      </div>

      <div v-show="selectedEdition" v-if="selectedVersion">
        <div
          class="hidden-md-and-up"
          style="padding-left: 12px; padding-right: 12px"
        >
          <v-row>
            <h1>{{ $t("Please select a platform") }}</h1>
          </v-row>
          <v-row>
            <v-select
              v-model="selectedOS"
              v-bind:items="selectedVersion.OS"
              item-text="name"
              return-object
            ></v-select>
          </v-row>
        </div>

        <v-row>
          <v-col cols="3" class="text-center hidden-sm-and-down">
            <template v-for="(os, i) in selectedVersion.OS">
              <base-select-operating-system-card
                :key="os.name"
                align="center"
                v-bind="os"
                v-on:item-click="onOSClick(os)"
                v-bind:color="osSelectedColor(os)"
              />

              <v-divider
                v-if="i + 1 !== selectedVersion.OS.length"
                :key="`divider-${i}`"
                class="my-8"
              />
            </template>
          </v-col>

          <v-col cols="2" class="hidden-sm-and-down text-center">
            <v-responsive height="calc(100% - 16px)" class="mt-2">
              <v-divider vertical />
            </v-responsive>
          </v-col>

          <v-col cols="12" md="7" v-if="selectedOS">
            <base-subheading
              size="display-1"
              v-bind:title="selectedOS.name"
              space="0"
            />

            <base-title
              class="primary--text"
              v-bind:title="$t('DOWNLOAD OPTIONS')"
              tag="div"
            />

            <div
              v-for="download in selectedOS.downloads"
              v-bind:key="download.filename"
              style="margin-left: 12px; margin-bottom: 24px"
            >
              <v-row>
                <base-subheading
                  style="
                    font-size: 24px !important;
                    margin-bottom: 0px !important;
                  "
                  >{{ $t(download.type) }}</base-subheading
                >
              </v-row>

              <v-row>
                <base-download-description
                  v-bind:download-type="download.type"
                ></base-download-description>
              </v-row>

              <v-row>
                <!-- TODO: use ping tag to POST to our counting-service -->
                <a
                  v-bind:href="`${
                    selectedVersion.baseURL
                      ? selectedVersion.baseURL
                      : `https://github.com/theMK2k/Media-Hoarder/releases/download/${selectedVersion.version}/`
                  }${download.filename}`"
                  v-bind:ping="`https://count.hostco.de/?c=media-hoarder&a=download-app&p1=${
                    download.typeId
                  }&p2=${
                    selectedVersion.version
                      ? selectedVersion.version.replace('v', '')
                      : null
                  }&p3=${selectedEdition ? selectedEdition.title : null}`"
                  target="_blank"
                  rel="noopener noreferrer"
                  ><base-btn>{{ download.filename }}</base-btn></a
                >
              </v-row>
              <v-row>
                {{ $t("verify with") }}
                <a
                  v-bind:href="`${
                    selectedVersion.baseURL
                      ? selectedVersion.baseURL
                      : `https://github.com/theMK2k/Media-Hoarder/releases/download/${selectedVersion.version}/`
                  }${download.filename}.sha256`"
                  v-bind:ping="`https://count.hostco.de/?c=media-hoarder&a=download-sha256&p1=${
                    download.typeId
                  }&p2=${
                    selectedVersion.version
                      ? selectedVersion.version.replace('v', '')
                      : null
                  }&p3=${selectedEdition ? selectedEdition.title : null}`"
                  target="_blank"
                  rel="noopener noreferrer"
                  style="margin-left: 4px"
                  >{{ `${download.filename}.sha256` }}</a
                >
              </v-row>
            </div>
          </v-col>
        </v-row>
      </div>
      <div>
        <strong>{{ $t("Join the discussions at GitHub") }}</strong
        >:
        <a
          target="_blank"
          rel="noreferrer noopener nofollow"
          href="https://github.com/theMK2k/Media-Hoarder/discussions"
          >https://github.com/theMK2k/Media-Hoarder/discussions</a
        >
      </div>
    </v-container>
  </base-section>
</template>

<script>
import PricingPlan from "@/views/sections/PricingPlan";
const downloads = require("@/downloads.json");

export default {
  name: "SectionDownloads",

  components: {
    "pricing-plan": PricingPlan,
  },

  data: () => ({
    selectedEdition: null,
    selectedVersion: {},
    selectedOS: {},

    cards: [
      {
        title: "Graphic Design",
        icon: "mdi-mouse",
      },
      {
        title: "Marketing",
        color: "primary",
        dark: true,
        icon: "mdi-headphones",
      },
      {
        title: "Development",
        icon: "mdi-vuetify",
      },
    ],
    marketing: [
      "Search Engine optimization",
      "Virtual Marketing",
      "Content Management",
      "Virtual Marketing",
      "Keyword Analysis",
      "Content Management",
    ],
  }),

  computed: {
    downloads() {
      return downloads;
    },
  },

  methods: {
    onPlanSelected(plan) {
      console.log("Downloads onPlanSelected plan:", plan);
      this.selectedEdition = plan;

      console.log(
        "this.selectedEdition:",
        JSON.stringify(this.selectedEdition, null, 2)
      );

      setTimeout(() => {
        this.$refs.selectEdition.scrollIntoView();
      }, 10);

      // const yTarget = window.innerWidth > 959 ? 560 : 420;
      // window.scrollTo(0, yTarget);
      // console.log("window.innerWidth:", window.innerWidth, "yTarget:", yTarget);

      setTimeout(() => {
        if (plan && plan.amount) {
          const url = `https://paypal.me/themk2k/${plan.amount}USD`;
          window.open(url);
        }
      }, 500);
    },

    onOSClick(os) {
      this.selectedOS = os;
    },

    osSelectedColor(os) {
      if (this.selectedOS === os) {
        return "primary";
      }

      return null;
    },

    onVersionChanged() {
      this.selectedOS = this.selectedVersion
        ? this.selectedVersion.OS.find(
            (os) => os.name === this.userPlatform()
          ) || this.selectedVersion.OS[0]
        : null;
    },

    userPlatform() {
      const platform = navigator.platform;
      const macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"];
      const windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"];

      if (macosPlatforms.indexOf(platform) !== -1) {
        return "MacOS";
      } else if (windowsPlatforms.indexOf(platform) !== -1) {
        return "Windows";
      } else if (/Linux/.test(platform)) {
        return "Linux";
      }

      return null;
    },
  },

  /**
   * Lifecycle Hooks
   */
  created() {
    console.log("navigator:", navigator);

    this.selectedVersion = this.downloads[0];

    this.onVersionChanged();
  },
};
</script>
